export default __webpack_public_path__ + "static/media/iconn1.e0ba0814.svg";